var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2188_43927)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.57255 6.01333L10.1859 6.62667L4.14589 12.6667H3.53255V12.0533L9.57255 6.01333ZM11.9726 2C11.8059 2 11.6326 2.06667 11.5059 2.19333L10.2859 3.41333L12.7859 5.91333L14.0059 4.69333C14.0677 4.63166 14.1167 4.5584 14.1502 4.47775C14.1836 4.3971 14.2008 4.31065 14.2008 4.22333C14.2008 4.13602 14.1836 4.04957 14.1502 3.96892C14.1167 3.88827 14.0677 3.81501 14.0059 3.75333L12.4459 2.19333C12.3126 2.06 12.1459 2 11.9726 2ZM9.57255 4.12667L2.19922 11.5V14H4.69922L12.0726 6.62667L9.57255 4.12667Z",
    fill: "#2173FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9718 2C11.8052 2 11.6318 2.06667 11.5052 2.19333L10.2852 3.41333L12.7852 5.91333L14.0052 4.69333C14.067 4.63166 14.116 4.5584 14.1494 4.47775C14.1829 4.3971 14.2001 4.31065 14.2001 4.22333C14.2001 4.13602 14.1829 4.04957 14.1494 3.96892C14.116 3.88827 14.067 3.81501 14.0052 3.75333L12.4452 2.19333C12.3118 2.06 12.1452 2 11.9718 2Z",
    fill: "#04245C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2188_43927"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.199219)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditOutline);
export default __webpack_public_path__ + "static/media/edit_outline.7fe27122c98c8881e532b3a205034d51.svg";
export { ForwardRef as ReactComponent };